export default __webpack_public_path__ + "static/media/24.7e91900b.png";